export default __webpack_public_path__ + "static/media/GelBoxFullOpen.fdfbc186.svg";